import { DrawerBody, Stack, Skeleton } from '@chakra-ui/react';

import { Header } from './Header';
import { Footer } from './Footer';
import { Content } from './Content';
import { Filter, IActiveFilters } from 'types';
import { useCallback, useState } from 'react';
import { filterIsActive } from '../filterFactoryMethods';

import { filterNameMap, isMatchAll } from '../../../../utilities/tagFilterCheck';
import { MatchAnyOrAll } from './MatchAnyOrAll';

export interface IProps {
  filter: Filter;
  onCloseFilterSetup: () => void;
  activeFilters: IActiveFilters;
  loading?: boolean;
  hasClearThisFilters?: boolean;
  onFilterConfirmLabel?: string;
  opened?: boolean;
  initialSearchValue?: string;
}
export interface IDispatchProps {
  saveFilter: (key: string, values: string[] | number[]) => void;
  onSearchChange?: (searchString: string) => void;
}

export const FilterSetup = ({
  filter,
  onCloseFilterSetup,
  activeFilters,
  saveFilter,
  hasClearThisFilters,
  onFilterConfirmLabel,
  loading,
  opened,
  onSearchChange,
  initialSearchValue,
}: IProps & IDispatchProps): JSX.Element | null => {
  const [search, setSearch] = useState<string>(initialSearchValue || '');

  const handleSearchChange = useCallback(
    function (newSearchValue: string) {
      setSearch(newSearchValue);
      if (onSearchChange) onSearchChange(newSearchValue);
    },
    [setSearch, onSearchChange],
  );

  if (!opened) return null;
  const tagFilterMatchName = filterNameMap[filter.key] ?? null;
  const isMatchAllEnabled = isMatchAll(filter.key);

  return (
    <>
      <Header filter={filter} onCloseFilterSetup={onCloseFilterSetup} search={search} setSearch={handleSearchChange} />

      <DrawerBody data-selector={`filter-setup-${filter.key}`}>
        {loading ? (
          <Stack mt="4" spacing="6" px="3">
            <Skeleton height="4" />
            <Skeleton height="4" />
            <Skeleton height="4" />
          </Stack>
        ) : (
          <>
            {tagFilterMatchName && (
              <MatchAnyOrAll filterName={tagFilterMatchName} isMatchAll={isMatchAllEnabled} saveFilter={saveFilter} />
            )}
            <Content filter={filter} search={search} activeFilters={activeFilters} saveFilter={saveFilter} />
          </>
        )}
      </DrawerBody>

      <Footer
        filter={filter}
        onCloseFilterSetup={onCloseFilterSetup}
        saveFilter={saveFilter}
        isActive={filterIsActive(filter, activeFilters)}
        hasClearThisFilters={hasClearThisFilters}
        onFilterConfirmLabel={onFilterConfirmLabel}
      />
    </>
  );
};
